<template>
  <v-flex>
    <v-card-title>
      <v-layout row justify-left>
        <v-dialog v-model="showDialog">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" v-on="on" @click="AdaugaButtonText">{{
              schema.showDialogBtnText
            }}</v-btn>
          </template>
          <v-card>
            <v-card-title>{{ schema.dialogueTitle }}</v-card-title>
            <v-card-text>
              <v-container>
                <v-layout wrap>
                  <RDWidget
                    v-for="(item, key) in schema.innerSchema"
                    :key="key"
                    ref="key"
                    :input-key="key"
                    :schema="item"
                    @inputChange="setRowValue"
                  ></RDWidget>
                </v-layout>
                <v-layout justify-center wrap>
                  <v-btn
                    id="addBtn"
                    color="blue-grey"
                    class="white--text"
                    @click="addRow"
                    >Adaugă</v-btn
                  >
                  <v-btn
                    color="red"
                    class="white--text"
                    @click="showDialog = false"
                    >Anulează</v-btn
                  >
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-card-title>
    <v-data-table
      :headers="schema.headers"
      :items="initialValue !== null ? initialValue : []"
      :rows-per-page-items="[25, 50, 100]"
      :pagination.sync="pagination"
      item-key="name"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td
            v-for="(header, index) in schema.headers"
            :key="index"
            :class="header.textClass"
          >
            {{ props.item[header.value] }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import myApiInstance from '../APIService'

export default {
  name: 'CustomTableDialogue',
  components: {
    RDWidget: () => import('../ReactiveDynamicWidget')
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    schema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showDialog: false,
      currentInput: {
        values: {
          nrParcela: '',
          titluProprietate: '',
          suprafataArendata: ''
        }
      },
      auxRow: this.schema.values || {},
      inputValue: this.value || {},
      pagination: {
        sortBy: 'name'
      },
      formValue: {},
      innerSchemaValue: {}
    }
  },

  mounted() {
    console.log(
      'SCHEMA FROM MOUNTED --- ' + JSON.stringify(this.schema.selectedId)
    )
  },

  methods: {
    updateFormValue: function(newVal, key) {
      this.formValue[key] = newVal
    },
    AdaugaButtonText: function() {
      document.getElementById('addBtn').textContent = 'Adauga'
    },
    clearValues: function() {
      for (var key in this.currentInput.values) {
        if (this.currentInput.values.hasOwnProperty(key)) {
          this.currentInput.values[key] = ''
        }
      }
    },
    setRowValue: function(childVal, childKey) {
      console.log('CHILD KEY : --- ' + JSON.stringify(childKey))
      console.log('CHILD VAL : --- ' + JSON.stringify(childVal))
      this.currentInput.values[childKey] = childVal
      console.log(this.currentInput.values)
    },

    addRow: function() {
      console.log(
        'MESAJ TEST ADDROW' + JSON.stringify(this.currentInput.values)
      )
      console.log('ENTITY ID: ' + JSON.stringify(this.schema.entityId))
      console.log('FORM ID: ' + JSON.stringify(this.schema.crud))

      myApiInstance
        .createApi(
          this.currentInput.values,
          this.schema.entityId,
          this.schema.crud
        )
        .then(() => {
          console.log('SUCCES')
        })
        .catch(function(error) {
          console.log('Error', error)
        })
    }
  }
}
</script>
